module.exports = __webpack_public_path__ + "img/esp_qr.a7fc8967.jpeg";